import { useCallback, useMemo } from 'react';

import { DataStorageQuery } from 'dashboard-services/api/dataStorage';

import properties from 'resources/constants/properties.json';
import { CurvesUtils } from 'utils';

import { useQueries } from '@tanstack/react-query';

export default (() => {

  const useGetColumns = ({ selectedCurves, getQueryBuilder, source }) => {
    const queries = useMemo(() => 
      selectedCurves.map((curve, curveIndex) => ({
        ...DataStorageQuery.QUERIES.getSymbolColumns(getQueryBuilder, {
          groupName: curve.groupName,
          query: undefined,
          metadatas: { [CurvesUtils.ROOT]: curve.root, [CurvesUtils.PRODUCT]: curve.product },
          symbols: { [CurvesUtils.SYMBOL]: `${curve.root}_*` },
          size: 50,
          useEs: properties.useEsSymbolListing === "true",
          curveIndex,
          provider: source
        }),
        select: response => (response?.items || []).map(item => item?.name)
      })), [getQueryBuilder, selectedCurves, source]),
    combine = useCallback(results => ({
      data: results.map(result => result?.data).flat().toUnique().filter(v => !!v).sort((a, b) => a.localeCompare(b)).map(v => ({ label: v, value: v })),
      isPending: results.some(result => result.isPending)
    }), [])

    return useQueries({
      queries,
      combine
    })
  }

  return { 
    useGetColumns
  }
})()